export const restrictToNumbersOnly = (e) => {
  const key = e.which || e.keyCode;
  if (key < 48 || key > 57) {
    e.preventDefault();
  }
};